import { ReactNode } from "react";
import { Stack, Typography, Box } from "@mui/material";

type Props = {
  title: string;
  description?: string;
  action?: ReactNode;
};

const PageHeader = ({ title, description, action }: Props) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "flex-start", sm: "center" }}
      justifyContent="space-between"
      gap={2}
      sx={{ mb: 0 }}
    >
      <Box>
        <Typography
          variant="h1"
          component="h1"
          sx={{ fontSize: { xs: "1.375rem", md: "1.5rem" } }}
        >
          {title}
        </Typography>
        {description && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.75, maxWidth: 560, lineHeight: 1.6 }}
          >
            {description}
          </Typography>
        )}
      </Box>
      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Stack>
  );
};

export default PageHeader;
